import React, { useEffect } from 'react';
import { canUseDOM } from '../../../utils';
import { ReactComponent as ChevronArrowDown } from '../../../resources/icons/chevron-bold.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var CategoryTilesCard = function CategoryTilesCard(_ref) {
  var item = _ref.item,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params,
    index = _ref.index;
  var calculateTitleBlockHeight = function calculateTitleBlockHeight() {
    var title = document.getElementById("title".concat(index));
    var information = document.getElementById("information".concat(index));
    var isDesktop = canUseDOM && window.matchMedia("(min-width: 1200px)").matches;
    if (information) {
      if (isDesktop) {
        information.style.maxHeight = title ? "".concat(title.getBoundingClientRect().height, "px") : "30px";
        return;
      }
      information.style.maxHeight = "initial";
    }
  };
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(function () {
        calculateTitleBlockHeight();
      }, 300);
      window.addEventListener('resize', calculateTitleBlockHeight);
      document.addEventListener("resize", calculateTitleBlockHeight);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener('resize', calculateTitleBlockHeight);
        document.removeEventListener("resize", calculateTitleBlockHeight);
      }
    };
  }, []);
  var analyticsImageHandler = function analyticsImageHandler(e) {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageClickAnalytics'], params), item.title.jss.value);
  };
  var analyticsArrowHandler = function analyticsArrowHandler() {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageArrowClickAnalytics'], params), item.title.jss.value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cardWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: item.image.jss.value.src,
    alt: item.image.jss.value.alt,
    className: "image",
    onClick: function onClick(e) {
      return analyticsImageHandler(e);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "textContainer",
    onClick: function onClick(e) {
      return analyticsImageHandler(e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "information",
    id: "information".concat(index)
  }, /*#__PURE__*/React.createElement("p", {
    className: "title",
    id: "title".concat(index)
  }, item.title.jss.value), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, item.shortDescription.jss.value)), /*#__PURE__*/React.createElement("div", {
    className: "circleLink",
    onClick: analyticsArrowHandler
  }, /*#__PURE__*/React.createElement(ChevronArrowDown, {
    className: "arrowIcon"
  }))));
};
export { CategoryTilesCard };